import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { UploadService } from '../services/upload/upload.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(private injector: Injector) {}

  handleError(error: any): void {
    // Avoid circular dependency by getting UploadService lazily
    const uploadService = this.injector.get(UploadService, null);

    const message = error?.message || String(error);
    const stack = error?.stack || '';

    console.error('[GlobalErrorHandler]', error);

    if (uploadService) {
      uploadService.loggingService({
        Message: message,
        stack: stack,
        type: 'error',
      });
    }
  }
}
